export default __webpack_public_path__ + "static/media/quel_est_ce_pokemon.5b3310e3.jpg";